export const isSpecialCharacter = (character: string) => {
  const format = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;

  return format.test(character);
};
